import { Injectable, NgZone } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, interval, switchMap, map } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FacultyService {
  private baseUrl = `${environment.apiBaseUrl}/facultyR`;
  private baseUrlProcess = `${environment.apiBaseUrl}/processR`;
  private reportUrl = `${environment.apiBaseUrl}/reportR`;


  constructor(private http: HttpClient, private ngZone: NgZone) { }

  getBatches(userId: number): Observable<any> {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json', "authfor": "W"
    });
    const body = {
      "criteria": {
        "userId": userId,
        "tenant": null
      }
    };

    return this.http.post(`${this.baseUrl}/batches`, body, { headers });

    //return this.http.get(`${this.baseUrl}/batches?`,query );
  }

  // Live updates from Server-Sent Events (SSE)
  pushAutoVals(batchstatus: any): Observable<string> {
    return new Observable((observer) => {
      const eventSource = new EventSource(`${this.baseUrl}/autovals`, batchstatus);

      eventSource.onmessage = (event) => {
        this.ngZone.run(() => {
          observer.next(event.data);
        });
      };

      eventSource.addEventListener('end', () => {
        this.ngZone.run(() => {
          observer.complete();
        });
        eventSource.close();
      });

      eventSource.onerror = (error) => {
        this.ngZone.run(() => observer.error(error));
        eventSource.close();
      };

      return () => {
        eventSource.close();
      };
    });
  }


  processRound(batch: string): Observable<any> {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json', "authfor": "W"
    });
    const body = {
      criteria: {
        "batchid": batch,
        "tenant": null
      }
    };


    return this.http.post(`${this.baseUrlProcess}/process-round`, body, { headers });
  }



  pollStatus(processId: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', "authfor": "W"
    });
    const body = {
      criteria: {
        "processId": processId,
        "tenant": null
      }
    };


    return interval(2000).pipe(

      switchMap(() =>
        this.http.post(
          `${this.baseUrlProcess}/Getstatus`, body, { headers }
        )
      )
    );
  }
  getReports(batchstatus: any): Observable<any> {
    return this.http.get(`${this.baseUrl}/reports`, batchstatus);
  }

  pushEvents(batchstatus: any): Observable<any> {
    return this.http.get(`${this.baseUrl}/pushEvents`, batchstatus);
  }


  generateReport(userId: number, batchId: string, round: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', "authfor": "W"
    });
    const body = {
      "criteria": {
        "userId": userId,
        "BatchId": batchId,
        "RoundId": round,
        "tenant": null
      }
    };

    return this.http.post(`${this.reportUrl}/getExcelReport`, body, { headers });
  }

  downloadReport(dirPath: string): Observable<Blob> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authfor: 'W'
    });

    const body = {
      criteria: {
        dirPath: dirPath
      }
    };

    return this.http.post(
      `${this.reportUrl}/downloadExcelZip`,
      body,
      {
        headers,
        responseType: 'blob' // 🔥 REQUIRED FOR ZIP/EXCEL DOWNLOAD
      }
    );
  }


  getProductList(variantId: number, companyId: number): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', "authfor": "W"
    });

    const body = {
      "criteria": {

        "companyId": companyId,
        "tenant": null
      }
    };
    return this.http.post(`${this.reportUrl}/getProductList`, body, { headers });
  }

  getCompanyList(batchId: number, roundId: number): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', "authfor": "W"
    });

    const body = {
      "criteria": {
        "batchId": batchId,
        "roundId": roundId,
        "tenant": null
      }
    };
    return this.http.post(`${this.reportUrl}/getCompanyList`, body, { headers });
  }

  getFeatureList(batchId: number, roundId: number): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', "authfor": "W"
    });

    const body = {
      "criteria": {
        // "batchId": batchId,
        // "roundId": roundId,
        "tenant": null
      }
    };
    return this.http.post(`${this.reportUrl}/getFeatureList`, body, { headers });
  }

  getSegmentList(batchId: number, roundId: number): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', "authfor": "W"
    });

    const body = {
      "criteria": {
        // "batchId": batchId,
        // "roundId": roundId,
        "tenant": null
      }
    };
    return this.http.post(`${this.reportUrl}/getMasterParam`, body, { headers });
  }

  getAllEventList(variantId: number): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', "authfor": "W"
    });

    const body = {
      "criteria": {
        // "batchId": batchId,
        variantId: variantId,
        "tenant": null
      }
    };
    return this.http.post(`${this.reportUrl}/getEventList`, body, { headers });
  }

  submitEvent(event: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', "authfor": "W"
    });
    const body = {
      "criteria": event
    }
      ;
    return this.http.post(`${this.reportUrl}/submitEvent`, body, { headers });
  }

  getSEventData(batchId: number, roundId: number): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', "authfor": "W"
    });

    const body = {
      "criteria": {
        "BatchId": batchId,
        "RoundId": roundId,
        "tenant": null
      }
    };
    return this.http.post(`${this.reportUrl}/getEvent`, body, { headers });
  }

  restorePreviousRound(batchId: number, roundId: number): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json', "authfor": "W"
    });
    const body = {
      "criteria": {
        "BatchId": batchId,
        "RoundId": roundId,
        "tenant": null
      }
    };
    return this.http.post(`${this.reportUrl}/restorePreviousRound`, body, { headers });
  }

  getReportList(): Observable<any> {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json', "authfor": "W"
    });
    const body = {
      "criteria": {
        "tenant": null
      }
    };

    return this.http.post(`${this.reportUrl}/getPath`, body, { headers });

    //return this.http.get(`${this.baseUrl}/batches?`,query );
  }


}



